import { UNASSIGNED_KEY, scopeBucket } from "./scope-key.js";

const SORT_MODES = ["mark-asc", "mark-desc", "doc"];

function compareMarks(a, b) {
  return String(a).localeCompare(String(b), undefined, { numeric: true });
}

export function sortFrames(frames, mode) {
  const list = frames || [];
  if (mode === "doc") return list.slice();
  const sorted = list.slice().sort((a, b) => compareMarks(a.mark, b.mark));
  return mode === "mark-desc" ? sorted.reverse() : sorted;
}

export function nextSortMode(mode) {
  const idx = SORT_MODES.indexOf(mode);
  return SORT_MODES[(idx + 1) % SORT_MODES.length];
}

export function groupFrames(frames, mode, { scopeOf, pageLabelOf } = {}) {
  const list = frames || [];

  if (mode === "none") {
    return [{ key: "all", title: "all", frames: list.slice() }];
  }

  if (mode === "page") {
    const order = [];
    const byKey = new Map();
    for (const frame of list) {
      const label = pageLabelOf ? pageLabelOf(frame) : "";
      const key = label;
      let group = byKey.get(key);
      if (!group) {
        group = { key, title: label, frames: [] };
        byKey.set(key, group);
        order.push(group);
      }
      group.frames.push(frame);
    }
    return order;
  }

  if (mode === "scope") {
    const order = [];
    const byKey = new Map();
    let unassigned = null;
    for (const frame of list) {
      const { key, title } = scopeBucket(scopeOf ? scopeOf(frame) : "");
      if (key === UNASSIGNED_KEY) {
        if (!unassigned) unassigned = { key, title, frames: [] };
        unassigned.frames.push(frame);
        continue;
      }
      let group = byKey.get(key);
      if (!group) {
        group = { key, title, frames: [] };
        byKey.set(key, group);
        order.push(group);
      }
      group.frames.push(frame);
    }
    order.sort((a, b) =>
      a.title.localeCompare(b.title, undefined, { numeric: true }),
    );
    if (unassigned) order.push(unassigned);
    return order;
  }

  return [{ key: "all", title: "all", frames: list.slice() }];
}

export function visibleFrameOrder(groups) {
  const result = [];
  for (const group of groups || []) {
    for (const frame of group.frames || []) {
      result.push(frame);
    }
  }
  return result;
}

export function rangeBetween(orderedIds, anchorId, targetId) {
  const ids = orderedIds || [];
  const anchorIdx = ids.indexOf(anchorId);
  const targetIdx = ids.indexOf(targetId);
  if (anchorIdx === -1 || targetIdx === -1) return [];
  const start = Math.min(anchorIdx, targetIdx);
  const end = Math.max(anchorIdx, targetIdx);
  return ids.slice(start, end + 1);
}

export function scopeTotals(frames, { scopeOf, qtyOf } = {}) {
  const list = frames || [];
  const order = [];
  const byScope = new Map();
  let totalTypes = 0;
  let totalQty = 0;

  for (const frame of list) {
    const { key, title } = scopeBucket(scopeOf ? scopeOf(frame) : "");
    const qty = qtyOf ? qtyOf(frame) : 0;
    let entry = byScope.get(key);
    if (!entry) {
      entry = { scope: title, types: 0, qty: 0 };
      byScope.set(key, entry);
      order.push(entry);
    }
    entry.types += 1;
    entry.qty += qty;
    totalTypes += 1;
    totalQty += qty;
  }

  return { groups: order, total: { types: totalTypes, qty: totalQty } };
}
